// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { onAuthStateChanged, signOut, updateProfile } from 'firebase/auth';
// import { auth } from '../firebase/firebaseConfig';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setUser(user);
//       setLoading(false);
//     });
//     return () => unsubscribe();
//   }, []);

//   // const logout = () => signOut(auth);
//   // Radhika's Code
//   const logout = async () => {
//     try {
//       await signOut(auth);
//     } catch (error) {
//       console.error("Error signing out: ", error);
//     }
//   };

//   const updateUserProfile = async (updates) => {
//     try {
//       await updateProfile(auth.currentUser,updates);
//       setUser({ ...user, ...updates });
//     } catch (error) {
//       console.error("Error updating profile: ", error);
//     }
//   };

//   return (
//     <AuthContext.Provider value={{ user, logout }}>
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);


// import React, { createContext, useContext, useEffect, useState } from 'react';
// import {
//   onAuthStateChanged,
//   signOut,
//   updateProfile
// } from 'firebase/auth';
// import { auth } from '../firebase/firebaseConfig';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (currentUser) {
//         await currentUser.reload(); // Always reload to get latest verification status

//         const providerId = currentUser.providerData[0]?.providerId;

//         // Allow only verified email users or Google-authenticated users
//         if (currentUser.emailVerified || providerId === 'google.com') {
//           setUser(currentUser);
//         } else {
//           await signOut(auth);
//           setUser(null);
//         }
//       } else {
//         setUser(null);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   const logout = async () => {
//     try {
//       await signOut(auth);
//       setUser(null);
//     } catch (error) {
//       console.error("Error signing out:", error);
//     }
//   };

//   const updateUserProfile = async (updates) => {
//     try {
//       await updateProfile(auth.currentUser, updates);
//       setUser({ ...auth.currentUser, ...updates });
//     } catch (error) {
//       console.error("Error updating profile:", error);
//     }
//   };

//   return (
//     <AuthContext.Provider value={{ user, logout, updateUserProfile }}>
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);
import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signOut, updateProfile } from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';
import { Navigate ,useNavigate } from 'react-router-dom';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        await firebaseUser.reload();

        if (firebaseUser.emailVerified) {
          setUser(firebaseUser);
        } else {
          // Auto logout if not verified
          await signOut(auth);
          setUser(null);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const logout = async () => {
    try {
      await signOut(auth);
      setUser(null); // ✅ clear user from context
      navigate('/');
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  const updateUserProfile = async (updates) => {
    try {
      await updateProfile(auth.currentUser, updates);
      setUser({ ...auth.currentUser, ...updates });
    } catch (error) {
      console.error("Error updating profile: ", error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, logout, updateUserProfile }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

